import Image from "next/image";
import RazaJordanWhiteboard from "public/assets/documentary/raza-jordan-whiteboard.jpeg";
import { PageTitleAndHeroText } from "./PageTitleAndHeroText";

const BUILDING_THE_FUTURE = `
We're building the future in which AI does not replace humans
but gives people the tools to achieve things that today are
restricted to a tiny group of people with specialist expertise.
`;

const AboutUsHero = () => (
  <>
    <div className="container-xl">
      <div className=" mt-32 flex flex-col gap-x-48 gap-y-48 sm:mt-[88px] lg:mx-120 lg:flex-row lg:items-end lg:justify-between ">
        <div className="max-w-[640px] grow">
          <PageTitleAndHeroText
            title="Our Mission"
            text="Make programming computers as natural as teaching a colleague"
          />
        </div>

        <div className="hidden max-w-[32ch] shrink sm:block">
          <div className="text-14-24 text-gray-800">{BUILDING_THE_FUTURE}</div>
        </div>
      </div>
    </div>

    <div className="mt-32 mb-32 sm:mb-40 sm:mt-80">
      <div className="container-xl relative h-[256px] items-center overflow-y-hidden sm:h-320 md:h-480  lg:h-[640px]">
        <div className="grain  inset-0 opacity-90" />
        <Image
          priority
          className="brightness-125 contrast-[1.10] grayscale"
          src={RazaJordanWhiteboard}
          alt=""
          layout="fill"
          objectFit="cover"
        />
      </div>
    </div>

    <div className="container-xl mb-48">
      <div className="block max-w-[32ch] sm:hidden">
        <div className="text-14-24 text-gray-800">{BUILDING_THE_FUTURE}</div>
      </div>
    </div>
  </>
);

export default AboutUsHero;
